import siteConfig from '../config/site.json';

export const getConfig = (path) => {
  return path.split('.').reduce((obj, key) => obj?.[key], siteConfig);
};

export const getSiteName = () => getConfig('siteName');
export const getLogo = () => getConfig('logo');
export const getFooter = () => getConfig('footer'); 

export const getDisclaimer = () => getConfig('footer.disclaimer'); 

export const getContact = () => getConfig('footer.contact'); 

